import {FollowButton, FollowButtonReadonly} from '../lib/follow-button';
import {PressReleaseHeaderRoot} from './root';
import {PressReleaseHeaderRight} from './right';
import {PressReleaseHeaderCompanyName} from './company-name';
import {PressReleaseHeaderInternalLink} from './internal-link';
import {ResponsiveArea} from './responsive-area';

export const pressReleaseHeader = {
  root: PressReleaseHeaderRoot,
  right: PressReleaseHeaderRight,
  responseiveArea: ResponsiveArea,
  companyName: PressReleaseHeaderCompanyName,
  followButton: FollowButton,
  followButtonReadonly: FollowButtonReadonly,
  internalLink: PressReleaseHeaderInternalLink,
};
